// extracted by mini-css-extract-plugin
export default {"body":"LayoutInterno_body__VLGia","container":"LayoutInterno_container__OZPJ1"};